// 科研接口三元组字段：head 头实体、headType 头实体类型、relation 关系、
// tail 尾实体、tailType 尾实体类型，均为必需字段。
const toText = (value) => (value === null || value === undefined ? '' : String(value).trim());

export function parseResearchTriples(value) {
    const rows = [];
    // 接口返回对象数组：[{ head, headType, relation, tail, tailType }]
    if (Array.isArray(value)) {
        value.forEach((item) => {
            if (!item) return;
            const head = toText(item.head);
            const relation = toText(item.relation);
            const tail = toText(item.tail);
            if (!head || !relation || !tail) return;
            rows.push({
                head,
                headType: toText(item.headType),
                relation,
                tail,
                tailType: toText(item.tailType),
            });
        });
        return rows;
    }
    // 兼容字符串格式：头实体:头实体类型:关系:尾实体:尾实体类型;
    if (typeof value === 'string') {
        value.split(';').forEach((entry) => {
            const fields = entry.split(':').map((field) => field.trim());
            if (fields.length !== 5 || !fields.every(Boolean)) return;
            const [head, headType, relation, tail, tailType] = fields;
            rows.push({ head, headType, relation, tail, tailType });
        });
    }
    return rows;
}

// 图谱与三元组列表使用接口返回的两套独立字段：如图谱 caseReportGraph、三元组 caseReportTriple。
export function getResearchGraph(data, graphField, tripleField) {
    const graph = (data && data[graphField]) || {};
    return {
        nodes: Array.isArray(graph.nodes) ? graph.nodes : [],
        edges: Array.isArray(graph.edges) ? graph.edges : [],
        triples: parseResearchTriples(data && data[tripleField]),
    };
}

// 疾病名称取自接口返回的 data.diseaseName。
export function getResearchDiseaseName(data) {
    return (data && data.diseaseName) || '';
}

// 科研文献按 7 类分别返回独立数组字段，字段名与分类名称一一对应，均为必需字段。
export const RESEARCH_LITERATURE_TYPES = [
    { field: 'caseReportLiterature', title: '个案报道' },
    { field: 'famousDoctorExperienceLiterature', title: '名医经验' },
    { field: 'guidelineConsensusLiterature', title: '指南与共识' },
    { field: 'researchLiteratureSupportLiterature', title: '科研文献支撑' },
    { field: 'basicExperimentLiterature', title: '基础实验' },
    { field: 'reviewCommentaryLiterature', title: '述评与综述' },
    { field: 'clinicalTrialLiterature', title: '临床试验' },
];

// 检索分类固定为 7 类，筛选项与列表归属共用同一份顺序。
export const RESEARCH_LITERATURE_CATEGORIES = RESEARCH_LITERATURE_TYPES.map((item) => item.title);

// 文献元素字段：id、abstract（摘要）、title（标题）、type（分类）。
// 分类优先取元素自带的 type，缺失时回退为所属数组字段的分类名称。
export function getResearchLiterature(data) {
    const source = data || {};
    return RESEARCH_LITERATURE_TYPES.reduce((rows, { field, title }) => {
        const list = source[field];
        if (!Array.isArray(list)) return rows;
        list.forEach((item, index) => {
            if (!item) return;
            const id = toText(item.id);
            rows.push({
                id: id || `${field}-${index + 1}`,
                title: toText(item.title),
                abstract: toText(item.abstract),
                type: toText(item.type) || title,
                category: title,
            });
        });
        return rows;
    }, []);
}
